export default __webpack_public_path__ + "static/media/LoyaltyNone.0d26d95b.svg";